import React, { forwardRef } from 'react'

import styles from './styles.module.scss'
import cx from 'classnames'

const RadioButton = forwardRef(({ label, value, onChange, onChangeWithTarget, className, name, id, checked }, ref) => {
	const onChangeInput = event => {
		onChange && onChange(value)
		onChangeWithTarget && onChangeWithTarget(event)
	}

	const radioButtonCSS = cx(styles.RadioButtonContainer, className)

	return (
		<div className={radioButtonCSS}>
			<input
				id={id}
				ref={ref}
				className={styles.RadioButton}
				checked={checked}
				onChange={onChangeInput}
				name={name}
				type='radio'
			/>
			<label className={styles.RadioButton__label} htmlFor={id}>
				{label}
			</label>
		</div>
	)
})

export default RadioButton
